module.exports = __webpack_public_path__ + "img/40_38_034_570.f33435fc.jpg";